export default __webpack_public_path__ + "static/media/coupon.8f6bf9cf.jpg";